import { SortParams } from '../../../typings/grid';

export const SORT_INTERNAL_MARKETER_PRODUCTS = 'SORT_INTERNAL_MARKETER_PRODUCTS';
export type SORT_INTERNAL_MARKETER_PRODUCTS = typeof SORT_INTERNAL_MARKETER_PRODUCTS;

export interface SortInternalMarketerProducts {
    type: SORT_INTERNAL_MARKETER_PRODUCTS;
    sortParams: SortParams;
}

export function sortInternalMarketerProductsAction(sortParams: SortParams): SortInternalMarketerProducts {
    return {
        type: SORT_INTERNAL_MARKETER_PRODUCTS,
        sortParams
    };
}
